import React, { useEffect, useState } from 'react';
import { Navbar } from "@/components/Navbar";
import { VideoMaskHero } from "@/components/VideoMaskHero";
import { SectionRenderer } from "@/components/SectionRenderer";
import { Footer } from "@/components/Footer";
import { EventTicker } from "@/components/EventTicker";
import { AwardBadge } from "@/components/AwardBadge";
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const response = await axios.get(`${API}/pages/home`);
        setPageData(response.data);
      } catch (error) {
        console.error("Failed to fetch home page", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPage();
  }, []);

  if (loading) return <div className="h-screen flex items-center justify-center bg-sage-50 text-sage-500 animate-pulse">Loading TEAMWERK...</div>;

  return (
    <div className="min-h-screen bg-transparent font-sans text-concrete-900 selection:bg-sage-200 selection:text-sage-900">
      
      {/* Global Navbar */}
      <Navbar /> 
      
      {/* Event Ticker (Floating) */}
      <EventTicker />
      
      {/* Award Badge - dezent rechts unten */}
      <AwardBadge />

      {/* Unsichtbare Hauptüberschrift für Suchmaschinen und Screenreader (2026-11-04) */}
      <h1 className="sr-only">teamWERK Erolzheim: Coworking Space, Tagungsräume und Events zwischen Allgäu und Oberschwaben</h1>

      <VideoMaskHero />
      
      {/* Main Content */}
      <main className="relative z-20 bg-white shadow-2xl">
        {pageData?.sections?.length ? (
          pageData.sections.map((section, index) => (
            <SectionRenderer key={index} section={section} />
          ))
        ) : (
          <div className="py-24 px-4 md:px-12 text-center bg-white">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-black mb-4">
              Inhalte konnten nicht geladen werden
            </h2>
            <p className="text-concrete-600 mb-6 max-w-md mx-auto">
              Bitte prüfen Sie Ihre Internetverbindung und laden Sie die Seite neu.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-black text-white hover:bg-concrete-800 px-6 py-3 uppercase tracking-widest text-sm"
            >
              Seite neu laden
            </button>
          </div>
        )}
        <Footer />
      </main>

    </div>
  );
};

export default Home;
